import React from 'react'
import { HeadingColumns } from './s'
import { FlexChild } from 'components/flex'
import ModuleTitle from 'components/module-title'
import AddArticle from './add'

const NewsHero = ({ upgradable, manageAccess }) => (
    <HeadingColumns>
        <FlexChild>
            <ModuleTitle which="news" />
        </FlexChild>
        {(!!manageAccess && !upgradable) && <AddArticle />}
    </HeadingColumns>
)

export default NewsHero